import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailWithShadow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 198,
	height: 148,
	viewBox: "0 0 198 148",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 35.9736,
			y: 43.1035,
			width: 136.388,
			height: 79.4157,
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.6914 63.415C56.6914 62.3105 57.5868 61.415 58.6914 61.415H60.2363C60.762 61.415 61.2665 61.622 61.6408 61.9911L117.476 117.063C118.254 117.831 119.504 117.831 120.283 117.064L176.228 61.9898C176.602 61.6215 177.106 61.415 177.631 61.415H179.066C180.171 61.415 181.066 62.3105 181.066 63.415V144.604C181.066 145.708 180.171 146.604 179.066 146.604H58.6914C57.5868 146.604 56.6914 145.708 56.6914 144.604V63.415Z",
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.476 146.608H64.128C62.3777 146.608 61.4718 144.519 62.668 143.241L117.043 85.1667C117.835 84.3204 119.178 84.3229 119.968 85.1721L173.941 143.247C175.13 144.526 174.223 146.608 172.476 146.608Z",
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M179.01 60.1602L58.7506 60.1602C56.9515 60.1602 56.0672 62.3504 57.362 63.5996L117.714 121.822C118.491 122.572 119.723 122.57 120.497 121.817L180.404 63.5944C181.691 62.343 180.805 60.1602 179.01 60.1602Z",
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.8534 31.012L39.7762 9.14848M31.5096 36.9091L16.844 18.2645M23.771 46.7978L2.48704 38.4797",
			stroke: "#F385FF",
			strokeWidth: 3,
			strokeLinecap: "square"
		})
	]
});
export default SvgEmailWithShadow;
